import { mapState, mapActions } from 'vuex'

export default {
  computed: {

    stateName: {
      get () {
        return this.ganttItem.name
      },

      set (value) {
        this.setGanttItemProperty({ property: 'name', value })
      }
    },

    stateStageId: {
        get () {
          return this.ganttItem.stage_id
        },

        set (value) {
          this.setGanttItemProperty({ property: 'stage_id', value })
        }
    },

    stateClientId: {
        get () {
          return this.ganttItem.client_id
        },

        set (value) {
          this.setGanttItemProperty({ property: 'client_id', value })
        }
    },

    stateBudgetId: {
      get () {
        return this.ganttItem.budget_id;
      },

      set (value) {
        this.setGanttItemProperty({ property: 'budget_id', value })
      }
    },

    stateApprovedHours: {
      get () {
        return this.ganttItem.approved_hours;
      },

      set (value) {
        this.setGanttItemProperty({ property: 'approved_hours', value })
      }
    },

    stateStartDate: {
        get () {
          return this.ganttItem.start_date
        },

        set (value) {
          this.setGanttItemProperty({ property: 'start_date', value })
        }
    },

    stateEndDate: {
        get () {
          return this.ganttItem.end_date
        },

        set (value) {
          this.setGanttItemProperty({ property: 'end_date', value })
        }
    },

    stateWorkdays: {
        get () {
          return this.ganttItem.workdays
        },

        set (value) {
          this.setGanttItemProperty({ property: 'workdays', value })
        }
    },

    stateConfirmed: {
        get () {
          return this.ganttItem.confirmed
        },

        set (value) {
          this.setGanttItemProperty({ property: 'confirmed', value })
        }
    },

  },

  methods: mapActions('projectsPlanner', ['setGanttItemProperty'])
}
